import { css } from "styled-components";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getColor from "../../../../utils/getColor";
import unit from "../../../../utils/unit";
import { activeColor, borderRadiusOnBiggerScreen, borderWidthOnBiggerScreen } from "./settings";
export var getInnerBorderRadius = function getInnerBorderRadius(theme) {
  return unit(theme.borderRadius[borderRadiusOnBiggerScreen] - borderWidthOnBiggerScreen);
};
export var isActiveCommonStyles = css(["content:\"\";position:absolute;z-index:1;border:0 solid ", ";pointer-events:none;"], function (props) {
  return getColor(props.theme, activeColor);
});
export var biggerScreenLastRowStyles = function biggerScreenLastRowStyles(activeColumnIndex) {
  return css(["div:last-child >{:first-child{border-bottom-left-radius:", ";}:last-child{border-bottom-right-radius:", ";}", "}"], function (props) {
    return getInnerBorderRadius(props.theme);
  }, function (props) {
    return getInnerBorderRadius(props.theme);
  }, activeColumnIndex !== undefined && css([":nth-child(", "){position:relative;&::after{", ";top:", ";right:", ";bottom:", ";left:", ";border-width:", ";}&:last-child::after{border-right-width:", ";border-bottom-right-radius:", ";}}"], activeColumnIndex + 2, isActiveCommonStyles, unit(-9999), unit(-1 * borderWidthOnBiggerScreen), unit(-1 * borderWidthOnBiggerScreen), unit(-1 * borderWidthOnBiggerScreen), unit(borderWidthOnBiggerScreen), unit(borderWidthOnBiggerScreen), function (props) {
    return getBorderRadius(props.theme, borderRadiusOnBiggerScreen);
  }));
};